import React from 'react'

const Errorpage = () => {
  return (
    <>
        <section className='Errorpage dark-bg'>

        </section>
    </>
  )
}

export default Errorpage
